var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Divider',{staticStyle:{"color":"#fff"},attrs:{"dashed":""}},[_vm._v("设置概览")]),_c('div',[_c('h4',{staticClass:"workplatform-title m-t-10 m-b-20"},[_vm._v("基础数据")]),_c('Table',{attrs:{"stripe":"","size":"small","data":_vm.list,"columns":_vm.tableColumns}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }